import React from 'react';
import * as ChartUI from '../ChartUI';
import { ChartMode, ChartViewType } from '../types';
import ErrorChartInfo from '../ErrorChartInfo';

interface IProps {
  mode: ChartMode;
}

const PermissionErrorChart = ({ mode }: IProps) => (
  <ChartUI.Container>
    <ChartUI.ChartMainWrapper $mode={mode}>
      <ErrorChartInfo type={ChartViewType.PermissionError} />
    </ChartUI.ChartMainWrapper>
  </ChartUI.Container>
);

export default PermissionErrorChart;
